import {
  Box,
  Button,
  Input,
  Select,
  Td,
  Text,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import BunnyVideoSelector from "../components/common/BunnyVideoSelector";
import DeleteModal from "../components/common/Modal/DeleteModal";
import CreateModal from "../components/common/Modal/Modal";
import PreviewModal from "../components/common/Modal/PreviewModal";
import CreateTable from "../components/common/Table/Table";
import CreateInput from "../components/common/TextInputs/Input";
import Fallback from "../components/common/ui/Fallback";
import Loading from "../components/common/ui/Loading";
import useActions from "../hooks/useActions";
import { useNavigator } from "../hooks/useNavigator";
import {
  createNewBanner,
  deleteBanner,
  getAllBanners,
  getAllMovies,
  getAllSeries,
  updateBanner,
  uploadFile,
} from "../utils/api";
import { videoAPI } from "../utils/bunnyApi";

const Banner = () => {
  const [banner, setBanner] = React.useState([]);
  const [update, setUpdate] = React.useState(false);
  const [newBanner, setNewBanner] = React.useState({});
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isBunnyOpen,
    onOpen: onBunnyOpen,
    onClose: onBunnyClose,
  } = useDisclosure();

  // Preview modal state
  const [previewModal, setPreviewModal] = React.useState({
    isOpen: false,
    url: "",
    title: "",
    urlType: "",
  });

  const [loading, setLoading] = React.useState(true);
  const [updateAction, deleteAction] = useActions();
  const [itemData, setItemData] = React.useState([]);
  const [itemType, setItemType] = React.useState("");

  // File upload handler for image type
  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const [success, link] = await uploadFile(file);
      if (success) {
        setNewBanner((prev) => ({ ...prev, url: link }));
        toast({
          title: "Success",
          description: "Image uploaded successfully",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } else {
        toast({
          title: "Error",
          description: "Failed to upload image",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    }
  };

  // Preview handler
  const handlePreview = (row) => {
    setPreviewModal({
      isOpen: true,
      url: row.url,
      title: `Banner Preview - ${row.origin}`,
      urlType: row.origin.toLowerCase(),
    });
  };

  const handleBunnyVideoSelect = (video) => {
    setNewBanner((prev) => ({
      ...prev,
      url: videoAPI.getPlaylistUrl(video.guid),
    }));
    toast({
      title: "Video selected",
      description: `"${video.title}" set as banner video URL`,
      status: "success",
      duration: 3000,
      isClosable: true,
    });
  };

  const bannersHandler = async () => {
    if (user?.getBanner) {
      const [success, data] = await getAllBanners();
      if (success) {
        setBanner(data);
      }
    }
    setLoading(false);
  };
  const getAllMovieHanler = async () => {
    setLoading(true);
    const [success, data] = await getAllMovies();
    if (success) {
      setItemData(data);
    }
    setLoading(false);
  };

  const getAllSeriesHandler = async () => {
    setLoading(true);
    const [success, data] = await getAllSeries();
    if (success) {
      setItemData(data);
    }
    setLoading(false);
  };
  useEffect(() => {
    if (itemType === "movie") {
      getAllMovieHanler();
    } else if (itemType === "series") {
      getAllSeriesHandler();
    }
  }, [itemType]);

  const [navigate, user] = useNavigator(bannersHandler);
  const createBanner = async () => {
    if (newBanner.position && newBanner.url && newBanner.origin) {
      setLoading(true);
      if (!update && user?.addBanner) {
        const [success, data] = await createNewBanner(newBanner);
        if (success) {
          toast({
            title: "Banner Created",
            description: "Banner Created Successfully",
            status: "success",
            duration: 9000,
            isClosable: true,
          });
          bannersHandler();
          onClose();
        } else {
          toast({
            title: "Banner Not Created",
            description: "Banner Not Created Successfully",
            status: "error",
            duration: 9000,
            isClosable: true,
          });
        }
      } else {
        await updateAction(
          {
            ...newBanner,
          },
          newBanner._id,
          updateBanner
        );
        setUpdate(false);
        onClose();
        bannersHandler();
      }
    } else {
      toast({
        title: "fill all fields",
        description: "Banner Not Created Successfully",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
    setLoading(false);
  };
  if (loading) {
    return <Loading />;
  }
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: "1rem",
      }}
    >
      {user?.addBanner && (
        <Button
          colorScheme="blue"
          variant="solid"
          onClick={() => {
            onOpen();
            setItemType("");
            setItemData({});
            setUpdate(false);
            setNewBanner({});
          }}
        >
          Create Banner
        </Button>
      )}
      {user?.getBanner ? (
        <CreateTable
          data={banner}
          head={["Image", "Position", "Origin", "Links"]}
          rows={(row) => {
            return (
              <>
                <Td>
                  <Button
                    colorScheme="teal"
                    variant="link"
                    onClick={() => handlePreview(row)}
                  >
                    Preview
                  </Button>
                </Td>
                <Td>{row.position}</Td>
                <Td>{row.origin}</Td>
                <Td>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      gap: 2,
                    }}
                  >
                    {user?.updateBanner && (
                      <Button
                        colorScheme={row.isEnable ? "red" : "green"}
                        variant="solid"
                        onClick={async () => {
                          setLoading(true);
                          await updateAction(
                            {
                              isEnable: !row.isEnable,
                            },
                            row._id,
                            updateBanner
                          );
                          setLoading(false);
                          bannersHandler();
                        }}
                        sx={{
                          width: "100%",
                        }}
                      >
                        {row.isEnable ? "Disable" : "Enable"}
                      </Button>
                    )}

                    {user?.updateBanner && (
                      <Button
                        colorScheme="blue"
                        variant="solid"
                        onClick={() => {
                          setNewBanner(row);
                          setUpdate(true);
                          onOpen();
                        }}
                        sx={{
                          width: "100%",
                        }}
                      >
                        Edit
                      </Button>
                    )}
                    {user?.deleteBanner && (
                      <DeleteModal
                        onClick={async () => {
                          setLoading(true);
                          await deleteAction(row._id, deleteBanner);
                          setLoading(false);
                          bannersHandler();
                        }}
                      />
                    )}
                  </Box>
                </Td>
              </>
            );
          }}
        />
      ) : (
        <Fallback />
      )}
      <CreateModal
        isOpen={isOpen}
        onClose={onClose}
        title="Create Banner"
        create={createBanner}
      >
        <Select
          value={newBanner?.origin ? newBanner.origin : ""}
          placeholder="Select origin"
          onChange={(e) => {
            setNewBanner((prev) => ({
              ...prev,
              origin: e.target.value,
            }));
          }}
        >
          <option value="Youtube">Youtube</option>
          <option value="Video">Video</option>
          <option value="Image">Image</option>
        </Select>

        {newBanner?.origin === "Image" ? (
          <Box>
            <Text fontSize={"md"} fontWeight={"semibold"} mb={2}>
              Upload Image
            </Text>
            <Input
              type="file"
              accept="image/*"
              onChange={handleImageUpload}
              sx={{
                border: "1px solid #e2e8f0",
                borderRadius: "0.375rem",
                padding: "0.5rem",
              }}
            />
            {newBanner?.url && (
              <Text fontSize="sm" color="green.500" mt={1}>
                ✓ Uploaded
              </Text>
            )}
          </Box>
        ) : newBanner?.origin === "Video" ? (
          <Box display="flex" flexDirection="column" gap={2} mb={2}>
            <Text fontSize="sm" color="gray.600">
              Pick a video from your Bunny library (HLS URL is filled
              automatically).
            </Text>
            <Input
              readOnly
              placeholder="Select video from Bunny"
              value={newBanner?.url ? newBanner.url : ""}
            />
            <Button colorScheme="blue" onClick={onBunnyOpen}>
              Select video (Bunny)
            </Button>
            {newBanner?.url && (
              <Button
                colorScheme="blue"
                variant="outline"
                onClick={() =>
                  setPreviewModal({
                    isOpen: true,
                    url: newBanner.url,
                    title: "Banner Video Preview",
                    urlType: "video",
                  })
                }
              >
                Preview
              </Button>
            )}
          </Box>
        ) : (
          <CreateInput
            name={"Url"}
            onChange={(e) => {
              setNewBanner((prev) => ({
                ...prev,
                url: e.target.value,
              }));
            }}
            value={newBanner?.url ? newBanner.url : ""}
          />
        )}

        <CreateInput
          name={"Position"}
          type="number"
          onChange={(e) => {
            setNewBanner((prev) => ({
              ...prev,
              position: e.target.value,
            }));
          }}
          value={newBanner?.position ? newBanner.position : ""}
        />
      </CreateModal>

      {/* Preview Modal */}
      <PreviewModal
        isOpen={previewModal.isOpen}
        onClose={() => setPreviewModal({ ...previewModal, isOpen: false })}
        url={previewModal.url}
        title={previewModal.title}
        urlType={previewModal.urlType}
      />

      <BunnyVideoSelector
        isOpen={isBunnyOpen}
        onClose={onBunnyClose}
        onSelect={handleBunnyVideoSelect}
        title="Select banner video (Bunny)"
      />
    </Box>
  );
};

export default Banner;
